import React, { FC } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, Redirect, RouteComponentProps, useLocation } from 'react-router-dom'
import { MTECategories, onDemandCategories, posterCategories } from '../categories'
import { setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import routes from 'src/routes'
import { toast } from 'react-toastify'
import { isEmpty } from 'lodash'

export const CategorySelection: FC<RouteComponentProps> = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { currentUser } = useSelector((state) => state.auth)

  const categories = (location.pathname === routes.onDemand) ? onDemandCategories : (location.pathname === routes.onDemandMTE) ? MTECategories : posterCategories
  
  useEffect(() => {
    dispatch(setPageTitle(location.pathname === routes.onDemand ? 'On Demand Gallery' : (location.pathname === routes.onDemandMTE) ? 'Meet The Expert' :'E-Poster Gallery'))
    dispatch(setPreviousPage(routes.lobby))
  }, [dispatch])

  if (!isEmpty(currentUser) && location.pathname === routes.onDemandMTE) {
    const mteAccess = currentUser?.selected_access_flags?.filter(flag => flag.includes('mte'))
    if (mteAccess.length <= 0) {
      toast('For delegate who registered for MTE only.', {
        toastId: 'accessToast',
      })
      return <Redirect to={{ pathname: '/lobby' }} />
    }
  }
  
  return (
    <div className="grid-container">
      {categories.map((item) => (
        <Link key={item.id} to={item.destination} className="card-thumbnail">
          <img src={item.thumbnail} width="80%" alt="thumbnail" />
          <span>{item.categoryName}</span>
        </Link>
      ))}
    </div>
  )
}
